import { getFunctions, httpsCallable } from "firebase/functions";
import {
  ISiteFxCuratedSource,
  ISiteFxMediaResolveRequest,
  ISiteFxMediaResolveResponse,
} from "../ts/Definitions";

export const resolveSiteFxMedia = async (
  request: ISiteFxMediaResolveRequest
): Promise<ISiteFxMediaResolveResponse | undefined> => {
  try {
    const resolver = httpsCallable<ISiteFxMediaResolveRequest, ISiteFxMediaResolveResponse>(
      getFunctions(),
      "resolveSiteFxMedia"
    );
    const response = await resolver(request);
    return response.data;
  } catch {
    return undefined;
  }
};

export const getAvailableSiteFxCategories = async (
  bypassCache = true,
  curatedSources?: ISiteFxCuratedSource[]
): Promise<string[]> => {
  const response = await resolveSiteFxMedia({
    category: "all",
    mediaTypes: ["image", "video", "audio"],
    bypassCache,
    curatedSources,
  });
  if (!response?.availableCategories?.length) return ["all"];
  return Array.from(new Set(["all", ...response.availableCategories]))
    .sort((a, b) => a.localeCompare(b));
};
